export const imageGenerationRoutes = [
	"prompt_enhancer",
	"text-to-vector/base/32",
	"text-to-vector/base/31",
	"text-to-vector/base/23",
	"text-to-vector/fast/23",
	"text-to-image/base/32",
	"text-to-image/base/31",
	"text-to-image/base/22",
	"text-to-image/base/23",
	"text-to-image/fast/22",
	"text-to-image/fast/23",
	"text-to-image/hd",
	"reimagine",
	"refine_faces",
	"restyle_portrait",
];

export const imageEditingRoutes = [
	"erase_foreground",
	"eraser",
	"video/background/remove",
	"background/remove",
	"background/blur",
	"replace_bg",
	"image_expansion",
	"increase_resolution",
	"crop",
	"face",
	"gen_fill",
	"enhance_image",
	"objects/remove",
];

export const productGenRoutes = [
	"product_placement",
	"product/cutout",
	"product/packshot",
	"product/shadow",
	"product/lifestyle_shot_by_text",
	"product/lifestyle_shot_by_image",
];

export const tailoredGenRoutes = ["text-to-image/tailored", "text-to-vector/tailored"];

export const searchRoutes = ["search_similar_images", "caption"];

export const adGenerationRoutes = ["campaign_generator"];

export const otherRoutes = ["style", "image_to_psd"];

export type RouteGroupKey =
	| "image_generation"
	| "image_editing"
	| "product_shot_editing"
	| "tailored_generation"
	| "ads_generation"
	| "others";

export const productGroupRouteMap: Record<RouteGroupKey, string[]> = {
	image_generation: imageGenerationRoutes,
	image_editing: imageEditingRoutes,
	product_shot_editing: productGenRoutes,
	tailored_generation: tailoredGenRoutes,
	ads_generation: adGenerationRoutes,
	others: otherRoutes,
};

export const routeToGroup: Record<string, string> = (() => {
	const map: Record<string, string> = {};
	Object.entries(productGroupRouteMap).forEach(([group, routes]) => {
		routes.forEach((route) => {
			map[route] = group;
		});
	});
	return map;
})();
